import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { FormGroup, FormControl, FormLabel, Col, Row } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import { employeesService, shiftPatternsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import * as ubicationsActions from "actions/ubicationsActions";
import { withTranslation } from "react-i18next";

import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
import { convertFromUTC } from "utils/datetime";
registerLocale("es", es);

class EmployeeShiftPatternEdit extends React.Component {
	constructor(props) {
		super(props);

		// console.log(props);

		const lockedId = props.lockedShiftPatternId
			? parseInt(props.lockedShiftPatternId, 10)
			: null;

		let employee_shift_pattern = {
			shift_pattern_id: lockedId && lockedId > 0 ? lockedId : 0,
			ubication_id: -1,
			start_day: moment().format("YYYY-MM-DD"),
			end_day: '',
			start_index: 0,
		};

		let isEdit = false;

		if (props.employee_shift_pattern) {
			employee_shift_pattern = {
				...props.employee_shift_pattern,
				shift_pattern_id: props.employee_shift_pattern.shift_pattern.id,
				start_index:
					props.employee_shift_pattern.start_index !== undefined &&
					props.employee_shift_pattern.start_index !== null
						? Number(props.employee_shift_pattern.start_index)
						: 0,
			};
			isEdit = true;

			if (props.employee_shift_pattern.ubication)
				employee_shift_pattern.ubication_id = props.employee_shift_pattern.ubication.id;
		} else if (lockedId && lockedId > 0) {
			employee_shift_pattern.shift_pattern_id = lockedId;
		}

		const max_length = isEdit
			? props.employee_shift_pattern.shift_pattern.length
			: lockedId && lockedId > 0
				? 28
				: 28;
		const length_options = this.setLengthOptions(max_length);

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			employee_shift_pattern,
			length_options,
			start_index_options: length_options,
		};
	}

	componentDidMount() {
		// Cargar los datos necesarios para los selectores
		this.loadSelectData();

		const selectedShiftPatternId =
			this.props.lockedShiftPatternId ||
			this.state.employee_shift_pattern.shift_pattern_id;
		if (selectedShiftPatternId && Number(selectedShiftPatternId) > 0) {
			this.getShiftPatternDetails(
				String(selectedShiftPatternId),
				!this.state.isEdit
			);
		}
	}

	loadSelectData = async () => {
		// Cargar patrones de turnos seleccionables (no hace falta la lista si la rueda va fija)
		if (
			!this.props.lockedShiftPatternId &&
			(!this.props.shift_patterns || this.props.shift_patterns.length === 0)
		) {
			await this.props.getSelectableShiftPatterns();
		}

		// Cargar ubicaciones
		if (!this.props.ubications || this.props.ubications.length === 0) {
			await this.props.getAllUbications({ enabled: true });
		}
	}

	setLengthOptions(limit, shiftPatternItems = []) {
		const length_options = [];

		for (var i = 0; i < limit; i++) {
			const shiftUbications =
				Array.isArray(shiftPatternItems) &&
				shiftPatternItems[i] &&
				Array.isArray(shiftPatternItems[i].shift_ubications)
					? shiftPatternItems[i].shift_ubications
					: [];
			const shiftsText = shiftUbications
				.filter((su) => su && su.shift)
				.map((su) => {
					const shift = su.shift;
					const intervals = Array.isArray(shift.time_intervals)
						? shift.time_intervals
								.map((ti) => {
									const start = convertFromUTC(ti.start);
									const end = convertFromUTC(ti.end);
									return start && end ? `${start}-${end}` : null;
								})
								.filter(Boolean)
						: [];
					return intervals.length > 0
						? `${shift.name} (${intervals.join(", ")})`
						: shift.name;
				})
				.join(" | ");
			length_options.push({
				index: i,
				label: shiftsText ? `Día ${i + 1} - ${shiftsText}` : `Día ${i + 1}`,
			});
		}

		return length_options;
	}

	getLengthFromShiftPattern(shift_pattern_id) {
		const { shift_patterns } = this.props;

		if (shift_pattern_id < 0 || shift_pattern_id === "-1") return 28;
		else {
			const shift_pattern = shift_patterns.find(
				(sp) => sp.id === parseInt(shift_pattern_id)
			);

			// Verificar si la rueda de turnos tiene la propiedad length
			if (shift_pattern && typeof shift_pattern.length === 'number') {
				return shift_pattern.length;
			} else {
				return 28;
			}
		}
	}

	handleChange = (event) => {
		if (
			this.props.lockedShiftPatternId &&
			event.target.id === "shift_pattern_id"
		) {
			return;
		}

		var { employee_shift_pattern, length_options } = this.state;

		if (event.target.id == "shift_pattern_id") {
			// Obtener la información completa de la rueda de turnos seleccionada
			this.getShiftPatternDetails(event.target.value);
		}

		this.setState({
			length_options,
			employee_shift_pattern: {
				...employee_shift_pattern,
				[event.target.id]: event.target.value,
			},
		});
	};

	getShiftPatternDetails = async (shift_pattern_id, resetStartIndex = true) => {
		const resolveStartIndex = (current) =>
			resetStartIndex
				? 0
				: current !== undefined && current !== null
					? Number(current)
					: 0;

		if (shift_pattern_id < 0 || shift_pattern_id === "-1") {
			// Si no hay rueda seleccionada, usar 28 como valor por defecto
			const length_options = this.setLengthOptions(28);
			this.setState({
				length_options,
				start_index_options: length_options,
				employee_shift_pattern: {
					...this.state.employee_shift_pattern,
					start_index: resolveStartIndex(
						this.state.employee_shift_pattern.start_index
					),
				},
			});
			return;
		}

		try {
			// Obtener la información completa de la rueda de turnos
			const response = await shiftPatternsService.getById(shift_pattern_id);

			if (response.ok) {
				const shift_pattern = response;
				const length = shift_pattern.length || 28;
				const length_options = this.setLengthOptions(
					length,
					shift_pattern.items || []
				);

				this.setState({
					length_options,
					start_index_options: length_options,
					employee_shift_pattern: {
						...this.state.employee_shift_pattern,
						start_index: resolveStartIndex(
							this.state.employee_shift_pattern.start_index
						),
					},
				});
			}
		} catch (error) {
			console.error('Error getting shift pattern details:', error);
			// En caso de error, usar 28 como valor por defecto
			const length_options = this.setLengthOptions(28);
			this.setState({
				length_options,
				start_index_options: length_options,
				employee_shift_pattern: {
					...this.state.employee_shift_pattern,
					start_index: resolveStartIndex(
						this.state.employee_shift_pattern.start_index
					),
				},
			});
		}
	};

	handleDateChange = (id, date) => {
		const { employee_shift_pattern } = this.state;

		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			employee_shift_pattern: {
				...employee_shift_pattern,
				[key]: value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	buildApiPayload = () => {
		const esp = this.state.employee_shift_pattern;
		const ubRaw = esp.ubication_id;
		const payload = {
			shift_pattern_id: Number(esp.shift_pattern_id),
			start_day: esp.start_day,
			end_day:
				esp.end_day === "" ||
				esp.end_day == null ||
				esp.end_day === undefined
					? null
					: esp.end_day,
			start_index: Number(esp.start_index),
		};
		if (ubRaw != null && Number(ubRaw) > 0) {
			payload.ubication_id = Number(ubRaw);
		} else {
			payload.ubication_id = null;
		}
		if (this.state.isEdit && esp.id != null) {
			payload.id = esp.id;
		}
		return payload;
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		const props = this.props;
		if (!props.employee || !props.employee.id) {
			toastr.error("Error", "No se pudo identificar al empleado.");
			return;
		}

		const payload = this.buildApiPayload();
		if (!payload.start_day) {
			toastr.warning("", "Indica la fecha de inicio.");
			this.setState({ submitted: true });
			return;
		}
		if (!payload.shift_pattern_id || payload.shift_pattern_id < 0) {
			toastr.warning("", "Selecciona una rueda de turnos.");
			this.setState({ submitted: true });
			return;
		}

		this.setState({ isLoading: true });
		let response = "";

		if (this.state.isEdit) {
			response = await employeesService.updateShiftPattern(
				props.employee.id,
				payload
			);
		} else {
			response = await employeesService.addShiftPattern(
				props.employee.id,
				payload
			);
		}

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					if (typeof props.getEmployeeShiftPatterns === "function") {
						props.getEmployeeShiftPatterns(props.employee.id);
					}
					if (typeof props.onAssignmentSaved === "function") {
						props.onAssignmentSaved();
					}
					if (typeof props.onDataChanged === "function") {
						props.onDataChanged();
					}
					props.handleClose();
				}
			);
		} else {
			// Mostrar errores en toast
			const formatted = errorFormating(response);
			const errorMessage = formatted?.general || response?.errors?.[0]?.description || this.props.t("shiftPatterns.form.saveError");
			toastr.error("Error", errorMessage);
			
			this.setState({
				isLoading: false,
				submitted: true,
				errors: formatted,
			});
		}
	};

	render() {
		const { shift_patterns, ubications, lockedShiftPatternId, lockedShiftPatternName } = this.props;
		const { employee_shift_pattern, start_index_options } = this.state;

		const patternSelectLocked = !!lockedShiftPatternId;

		const optionShiftPatternList =
			shift_patterns && shift_patterns.length > 0 &&
			shift_patterns.map((item, i) => {
				return (
					<option key={i} value={item.id}>
						{item.name}
					</option>
				);
			}, this);

		const optionIndexList =
			start_index_options && start_index_options.length > 0 &&
			start_index_options.map((item) => {
				return (
					<option key={item.index} value={item.index}>
						{item.label || `${this.props.t("shiftPatterns.form.day")} ${item.index + 1}`}
					</option>
				);
			}, this);
		const canSelectStartIndex =
			patternSelectLocked || Number(employee_shift_pattern.shift_pattern_id) > 0;

		const optionUbicationList =
			ubications && ubications.length > 0 &&
			ubications.map((item, i) => {
				return (
					<option key={i} value={item.id}>{item.name}</option>
				)
			}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="shift_pattern_id">
						<FormLabel>{this.props.t("shiftPatterns.form.shiftPattern")} <span className="label-required">*</span></FormLabel>
						<FormControl
							onChange={this.handleChange}
							value={
								patternSelectLocked
									? lockedShiftPatternId
									: employee_shift_pattern.shift_pattern_id
							}
							isInvalid={this.checkValidField("shift_pattern_id")}
							as="select"
							disabled={patternSelectLocked}
						>
							{patternSelectLocked ? (
								<option value={lockedShiftPatternId}>
									{lockedShiftPatternName ||
										`Rueda #${lockedShiftPatternId}`}
								</option>
							) : (
								<>
									<option value="-1">Seleccionar rueda de turno</option>
									{optionShiftPatternList}
								</>
							)}
						</FormControl>

						<FormControl.Feedback type="invalid">
							{this.state.errors.shift_pattern_id}
						</FormControl.Feedback>
					</FormGroup>

					<Row>
						<Col sm={6}>

							<FormGroup
								controlId="start_day"
								className={`form-group form-date ${employee_shift_pattern.start_day === "" && "empty"
									}  ${this.checkValidField('start_day') && "is-invalid"}`}
							>
								<FormLabel>{this.props.t("contracts.assignment.startDate")} <span className="label-required">*</span></FormLabel>

								<DatePicker
									selected={(employee_shift_pattern.start_day === "" || !employee_shift_pattern.start_day) ? employee_shift_pattern.start_day : moment(employee_shift_pattern.start_day).toDate()}
									onChange={(date) => this.handleDateChange("start_day", date)}
									isInvalid={this.checkValidField("start_day")}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale='es'
									placeholderText="dd/mm/aaaa"
								/>

								<FiCalendar />
								<FormControl.Feedback type="invalid">
									{this.state.errors.start_day}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup controlId="end_day" className={`form-group form-date ${this.checkValidField('end_day') && "is-invalid"}`}>
								<FormLabel>{this.props.t("contracts.assignment.endDate")}</FormLabel>

								<DatePicker
									selected={!employee_shift_pattern.end_day || employee_shift_pattern.end_day === "" ? "" : moment(employee_shift_pattern.end_day).toDate()}
									onChange={(date) => this.handleDateChange("end_day", date)}
									isInvalid={this.checkValidField("end_day")}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale='es'
									placeholderText="dd/mm/aaaa"
								/>

								<FiCalendar />
								<FormControl.Feedback type="invalid">
									{this.state.errors.end_day}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="start_index">
								<FormLabel>{this.props.t("shiftPatterns.form.startBy")}</FormLabel>
								<FormControl
									onChange={this.handleChange}
									value={employee_shift_pattern.start_index}
									isInvalid={this.checkValidField("start_index")}
									as="select"
									disabled={!canSelectStartIndex}
								>
									{optionIndexList}
								</FormControl>

								<FormControl.Feedback type="invalid">
									{this.state.errors.start_index}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="ubication_id">
								<FormLabel>{this.props.t("shiftPatterns.assignment.headerUbication")}</FormLabel>
								<FormControl
									onChange={this.handleChange}
									value={employee_shift_pattern.ubication_id}
									isInvalid={this.checkValidField('ubication_id')}
									as="select">
									<option value="-1">{this.props.t("shiftPatterns.form.selectUbication")}</option>
									{optionUbicationList}
								</FormControl>

								<FormControl.Feedback type="invalid">
									{this.state.errors.ubication_id}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (state, myProps) => {
	return {
		...state.employeesReducer,
		shift_patterns: state.shiftsReducer.select_shift_patterns,
		ubications: state.ubicationsReducer.ubications,
		employee: myProps.employee,
	};
};

export default connect(
	mapStateToProps,
	{
		...employeesActions,
		getSelectableShiftPatterns: shiftsActions.getSelectableShiftPatterns,
		getAllUbications: ubicationsActions.getAllUbications,
	}
)(withTranslation()(EmployeeShiftPatternEdit));
